

















































































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';

@Component
export default class GroupDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
}
